import { signal, WritableSignal } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { noop } from '@tmx/core';

export abstract class AbstractFormComponent<Type>
  implements ControlValueAccessor
{
  onChange: (value: Type) => void = noop;
  onTouched: () => void = noop;

  value: WritableSignal<Type>;
  touched = signal(false);
  disabled = signal(false);

  constructor(defaultValue: Type) {
    this.value = signal(defaultValue);
  }

  writeValue(value: Type) {
    this.value.set(value);
    this.onWriteValue();
  }

  onWriteValue() {
    /*
    This is an empty method that does not perform any operations. It is
    intended to be overridden by subclasses. The purpose of this method is to
    provide an optional hook that subclasses can use to execute additional
    logic whenever the writeValue method is called.
    */
  }

  registerOnChange(fn: (value: Type) => void) {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void) {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled.set(isDisabled);
  }

  markAsTouched() {
    if (!this.touched()) {
      this.onTouched();
      this.touched.set(true);
    }
  }
}
